import { createContext } from 'react';

/**
 * @typedef CarouselContextObject
 * @property {Number} currentIndex - The index of the active slide.
 * @property {JSX.Element[]} [slides] - The slides to display in the carousel.
 * @property {Function} handleNext - The function to call when the next slide should be displayed.
 * @property {Function} handlePrev - The function to call when the previous slide should be displayed.
 * @property {Function} handleSetIndex - The function to call when a specific slide should be displayed.
 */

/**
 * @type {React.Context<CarouselContextObject>}
 * @param {CarouselContextObject} param
 * @returns {React.Context}
 */

export const CarouselContext = createContext({});
